<ng-template #popoverTemplate>
    <div class="d-flex flex-column prislista-filter-container">
        <rask-header size="4">
            Filtrera marknadsprislistor
        </rask-header>

        <rask-tree-selector class="w-100"
            label="Region"
            [autoSort]="false"
            [items]="resultatomradeOptions">
        </rask-tree-selector>

        <div class="mt-1">
            <rask-checkbox [(ngModel)]="visaEndastVlg"
                text="Visa endast VLG-marknadsprislistor"></rask-checkbox>
        </div>
        <div>
            <rask-checkbox [(ngModel)]="visaInaktuella"
                text="Visa inaktuella marknadsprislistor"></rask-checkbox>
        </div>
        <div>
            <rask-checkbox [(ngModel)]="visaOavsettHsGrupper"
                text="Visa marknadsprislistor oavsett HS-grupper"></rask-checkbox>
        </div>

        <div class="d-flex justify-content-between">
            <rask-button color="primary" (click)="popover.close()">Stäng</rask-button>
            <rask-button color="secondary" (click)="reset()">Återställ</rask-button>
        </div>
    </div>
</ng-template>

<i #popover="ngbPopover"
    [ngbPopover]="popoverTemplate"
    [autoClose]="'outside'"
    (hidden)="popoverClosed()"
    popoverClass="prislista-filter-popover"
    container="body"
    placement="right"
    class="fas fa-filter prislista-filter-icon"
    [ngClass]="{'prislista-filter-active': filterActive}">
</i>